export const realtyTypesData = [
  {
    id: 1,
    domId: 'all',
    text: 'Вся недвижимость',
  },
  {
    id: 2,
    domId: 'com',
    text: 'Коммерческая недвижимость',
  },
];
